<div *ngIf="size == 'large'" class="loader" [style.top]="top + 'px'">
  <div class="spinner"></div>
  <div class="loader-message" *ngIf="text">{{ text }}</div>
</div>
